export const yandexMapLocaleDict = {
    ru: {
        searchPlaceholder: 'поиск...'
    },
    en: {
        searchPlaceholder: 'searching...'
    },
    th: {
        searchPlaceholder: 'กำลังค้นหา...'
    },
    tr: {
        searchPlaceholder: 'aranıyor...'
    }
};

